<template>
    <CustomButton :to="{ name: 'listOglobaOrder' }" label="Links.goBack" />
    <p class="page-title">Créer une carte cadeau ogloba</p>
    <div class="form-container">
        <div class="justify-center">
            <div class="mx-auto shadow-md p-6 rounded-lg w-[90%] md:w-[80%] lg:w-[50%]">
                <FormKit
                    type="form"
                    :value="true"
                    :actions="false"
                    incomplete-message="Désolé, tous les champs ne sont pas remplis correctement."
                    @submit="submitHandler"
                >
                    <FormKit type="autocomplete"
                             v-model="product"
                             name="product"
                             label="Enseigne *"
                             placeholder="Choisissez une enseigne"
                             validation="required"
                             :options="products"
                             :validation-messages="{
                                  required: 'Veuillez sélectionner une enseigne.',
                                }"
                    />
                    <div v-if="product">
                        <FormKit
                            v-model="amount"
                            type="number"
                            step="any"
                            label="Valeur faciale"
                            name="amount"
                            :disabled="product.isFixValue"
                            :validation-rules="{ validAmountVoucher }"
                            validation="validAmountVoucher|required"
                            :validation-messages="{
                       validAmountVoucher: validAmountVoucherEror,
                       required: 'Veuillez sélectionner une valeur faciale'
              }"
                        />
                        <span
                            v-if="!product.isFixValue &&  product.reloadList?.length" style="word-wrap: break-word;">Valeurs autorisées: {{ product.reloadList.toString() }} </span>
                        <span
                            v-if="!product.isFixValue &&  !product.reloadList?.length">Valeurs autorisées: {{ product.minCardAmount }}  à {{ product.maxCardAmount }}</span>
                    </div>
                    <br>
                    <FormKit
                        type="number"
                        number="integer"
                        label="Quantité"
                        name="quantity"
                        value="1"
                        validation="required|min:1|max:20"
                        :validation-messages="{
                       required: 'Veuillez saisir une quantité',
                       min:'Quantité ne peut pas être inférieure à 1.',
                       max:'Quantité ne peut pas être supérieure à 20.'
                      }"
                    />
                    <div class="flex mt-[1.5rem]">
                        <FormKit
                            type="submit"
                            label="Créer"
                            class="btn"
                            prefix-icon="check"
                        />
                    </div>
                </FormKit>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import ApiService from "@/_services/api.service";
import {onMounted, ref, watch} from "vue";
import swal from "@/_helpers/swal";
import router from "@/router";
import CustomButton from "@/components/forms/CustomButton.vue";

let products = ref([]);
let product: {} = ref();
let validAmountVoucherEror = ref('');
let amount = ref();

onMounted(async () => {
    await fetchOglobaProducts();
})

async function fetchOglobaProducts() {
    try {
        const response = await ApiService.get('admin/get-ogloba-products');
        products.value = response.data.data.map((item: never) => {
            return {
                label: item.productName, value: item, attrs: {disabled: !item.allowedActivate}
            };
        });
    } catch (error) {
        swal.error('Une erreur est survenue');
    }
}

async function submitHandler(data, formNode) {
    return ApiService.post("/admin/reserve-ogloba-product", {
        itemCode: data.product.itemCode,
        amount: parseFloat(data.amount),
        quantity: parseInt(data.quantity)
    }).then(({data}) => {
        swal.success("", "Les cartes ont été créées !");
        router.push({name: 'listOglobaOrder'});
    }).catch(({response}) => {
        swal.error(response?.data?.errors[0]?.message);
    });
}
function validAmountVoucher(node) {
    const amountValue = node.value;
    validAmountVoucherEror.value = '';
    if (product.value.isFixValue) {
        return true;
    }
    if (product.value.reloadList?.length) {
        if (product.value.reloadList.includes(amountValue)) {
            return true;
        }
        validAmountVoucherEror.value = 'La valeur ne fait pas partie de la liste autorisée pour cette enseigne.';
        return false;
    }
    if (amountValue <= product.value.maxCardAmount && amountValue >= product.value.minCardAmount) {
        return true;
    }
    validAmountVoucherEror.value = 'La valeur doit être entre ' + product.value.minCardAmount + ' et ' + product.value.maxCardAmount;
    return false;
}

watch(
    product,
    (value) => {
        amount.value = null;
        if (value && value.isFixValue) {
            amount.value = value.faceValue;
        }
    });

</script>


